<p-dialog header="Long Content" visible="ture" [style]="{width: '50vw'}" [baseZIndex]="10000">
  Are you sure you want to change Pay as you Go to Drop-in? If yes, then the services associated will be removed.
  buttons: Cancel / Yes, Continue
  <ng-template pTemplate="footer">
      <p-button icon="pi pi-check"  label="Yes" class="p-button-text"></p-button>
      <p-button icon="pi pi-times"  label="No"></p-button>
  </ng-template>
</p-dialog>
